import React, { Component } from 'react';

import News from './posts/news.js'
import Tradegecko from './posts/tradegecko.js'
import MCPayment from './posts/mcPayment.js'
import E27Helicap from './posts/e27_helicap.js'
import DealStreetHelicap from './posts/dealstreet_helicap.js'
import SingaporesCoassets from './posts/singapores_coassets.js'
import Shopback from './posts/shopback.js'
import SwedishCrowdfunding from './posts/swedish_crowdfunding.js'
import DealStreetMCPayment from './posts/dealstreet_mcpayment.js'
import Artivision from './posts/artivision.js'
import SingaporeCrowdfundingPlatform from './posts/singapore_crowdfunding_platform'
import GoldfieldsMoney from './posts/goldfields_money.js'
import Guavapass from './posts/guavapass.js'
import E27MCPayment from './posts/e27_mcpayment.js'
import Rakuten from './posts/rakuten.js'
import Navbar from '../Navbar'
import Footer from '../Footer'

import './news.css'
class BlogPosts extends Component {
  loadBlogPost = () =>{    
    var key = window.location.pathname;
    key = key.replace(/\//g, "");
    switch(key){
      case 'news':
      return <News />
      case 'global-saas-commerce-platform-tradegecko-raises-usd-10m-in-series-b-funding-led-by-tnb-aura-fund-1-aura-venture-fund':
      return <Tradegecko />
      case 'mc-payment-takes-long-view-on-going-cashless':
      return <MCPayment />
      case 'helicap-raises-us1-5m-seed-funding-round-led-by-singapores-ex-minister-of-state-teo-ser-luck':
      return <E27Helicap />
      case 'fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister':
      return <DealStreetHelicap />
      case 'singapores-coassets-is-first-crowdfunding-firm-to-list-in-australia-read-more-at-http-www-channelnewsasia-com-news-business-singapore-s-coassets-is-first-crowdfunding-firm-to-list-in-austr':
      return <SingaporesCoassets />
      case 'shopback-bags-25m-in-latest-funding-round':
      return <Shopback />
      case 'this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch':
      return <SwedishCrowdfunding />
      case 'singapore-mc-payment-acquires-controlling-stake-in-alipay-licensed-genesis':
      return <DealStreetMCPayment />
      case 'guavapass-gets-us5m-series-a-led-by-vickers-venture-partners':
      return <Guavapass />
      case 'thailands-2w-group-leads-s5m-investment-into-mc-payment-to-finance-expansion':
      return <E27MCPayment />
      case 'goldfields-money-offers-60m-merger-proposal':
      return <GoldfieldsMoney />
      case 'singapore-crowdfunding-platform-coassets-lists-on-asx':
      return <SingaporeCrowdfundingPlatform />
      case 'sgx-listed-artivision-to-buy-fintech-firm-mc-payment-for-upwards-of-59m':
      return <Artivision />
      case 'singapore-rewards-app-shopBack-raises-45m-led-by-ev-growth-rakuten':
      return <Rakuten />

      default:
      return <div>no article found</div>
    }
  }
  setPage = () =>{
    document.title = `33 Capital - NEWS `
    this.setState({ title: this.props.match.params.title})
  }
  componentDidUpdate(prevProps){
    if(prevProps.match.params.title !== this.props.match.params.title) this.setPage(this.props)
  }
  componentDidMount() {
    this.setPage()
  }
  render() {
    return (
      <div className="newsPosts">
        <Navbar />
        {this.loadBlogPost()}
        <Footer />
      </div>
    );
  }
}

export default BlogPosts;



// WEBPACK FOOTER //
// ./src/components/News/index.js